import React from "react";
import rightimg from "./img/82BBB87C-FE15-4785-8FAC-7FDD69585612.webp";
import "./style.css";

function Header({ scrollToComponent }) {
  return (
    <header className="flex flex-col lg:flex-row justify-center items-stretch py-4 lg:py-6">
      <div className="header-left lg:w-1/2 lg:text-left flex flex-col justify-around p-6">
        <div className="flex flex-col gap-y-3 text-white text-sm lg:text-base">
        <h1 className="text-base text-white lg:text-xl mb-3 sm:text-sm md:text-lg xl:text-2xl">
          Стильдүү жана сапаттуу AJAR MEBEL дүйнөсүнө кош келиңиз – сиз үчүн
          эң мыкты столдор жана стулдар!
        </h1>
          <p className="lg:w-full">
            Биздин компания 10 жылдан ашык тажрыйбага ээ болуп, сизге заманбап,
            сапаттуу жана узак мөөнөт бою кызмат кыла турган стол жана стулдарды
            сунуштайт. Ар бир бөлмө үчүн идеалдуу тандоо: үйүңүздүн, офисиңиздин
            же конок бөлмөңүздүн эмеректери. Биз сизге эң жогорку сапаттагы жана
            өзгөчө дизайндагы эмеректерди сунуштайбыз.
          </p>
          <p className="lg:w-full">
            Биз ар бир деталга көңүл буруп, эмеректердин колдонууга ыңгайлуулугун
            жана стильдүү көрүнүшүн камсыздайбыз. Биз сизге ыңгайлуу шарттарды
            сунуштайбыз: банк аркылуу бөлүп төлөө, жеткирүү жана жеке кеңеш
            берүү.
          </p>
        </div>
        <div className="flex flex-col gap-y-3 text-white text-sm sm:text-xs md:text-base lg:text-lg">
          <p className="font-bold">Биздин негизги артыкчылыктар:</p>
          <ul className="list-disc list-inside">
            <li>10 жылдык тажрыйба</li>
            <li>1 жылдык сапат кепилдиги</li>
            <li>Оптовый баалар</li>
            <li>Тез жана ишенимдүү жеткирүү</li>
          </ul>
        </div>
        <div className="mt-4 flex justify-center lg:justify-start">
          <button
            onClick={scrollToComponent}
            className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg shadow-md transition-all duration-200"
          >
            Коллекцияңы көрүү
          </button>
        </div>
        </div>
      <div className="justify-center items-center hidden lg:flex">
        <img
          src={rightimg}
          alt="img"
          className="w-[450px] h-full cover"
          />
      </div>
    </header>
  );
}

export default Header;
